<template>
  <div id="search-title-modal" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <!--<h5 class="modal-title">Modal title</h5>-->
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <fields :fields="fields.all()" :model="model" />
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="submit">
            {{ $t("Save") }}
          </button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            {{ $t("Close") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResourceFormMixin from "../mixins/ResourceFormMixin";

export default {
  name: "SearchTitleModal",

  mixins: [ResourceFormMixin],

  data() {
    return {
      model: { name: "" },
    };
  },

  created() {
    this.setFields([
      {
        attribute: "name",
        component: "text-field",
        label: this.$t("Search name"),
      },
    ]);
  },

  mounted() {
    $("#search-title-modal").on("shown.bs.modal", () => {
      this.model = {
        name: this.$moment().format("LLL"),
      };
    });
    $("#search-title-modal").on("hidden.bs.modal", () => this.clear());
  },

  methods: {
    show() {
      $("#search-title-modal").modal("show");
    },

    hide() {
      $("#search-title-modal").modal("hide");
    },

    clear() {
      this.model = {};
    },

    submit() {
      this.$emit("submit", this, this.model);
    },
  },
};
</script>
